import { IMonthYearPopupProps } from "@components/inputs/date/popup/MonthYearPopup";
import { getValidDayjsDate } from "@components/inputs/date/utils";
import { Dayjs } from "dayjs";
import React from "react";

import { DatePickerView } from "../../../../enums";
import DateType, { getUtcDayjs } from "../../../../types/Date";
import memoizeOneWithParamsCheck from "../../../../utils/memoizeOne";
import { Calendar } from "./Calendar";
import { IDateSingleValuePopupSharedProps } from "./Calendar.utils";

export interface IYearPopupProps extends IDateSingleValuePopupSharedProps {
    previewValue?: Date;
}

interface IState {
    previewDay: Dayjs;
}

export default class YearPopup extends React.PureComponent<IYearPopupProps, IState> {
    static defaultProps: Partial<IYearPopupProps> = {
        disableAutoFocus: true
    };

    constructor(props: IMonthYearPopupProps) {
        super(props);
        this.state = {
            previewDay: getValidDayjsDate(this.props.value ?? this.props.previewValue),
        };
    }

    componentDidUpdate(prevProps: Readonly<IMonthYearPopupProps>) {
        if (this.props.value !== prevProps.value && DateType.isValid(this.props.value)) {
            this.setState({ previewDay: getValidDayjsDate(this.props.value) });
        }
    }

    handleCalendarChange = (day: Dayjs): void => {
        this.props.onChange(day.toDate());
    };

    getValue = memoizeOneWithParamsCheck(() => {
        return !this.props.value ? null : getUtcDayjs(this.props.value);
    }, () => [this.props.value]);

    handlePreviewChange = (day: Dayjs): void => {
        this.setState({
            previewDay: day
        });
    };

    render = (): React.ReactElement => {
        return (
                <Calendar previewDay={this.state.previewDay}
                          value={this.getValue()}
                          view={DatePickerView.Years}
                          mainView={DatePickerView.Years}
                          onChange={this.handleCalendarChange}
                          minDate={this.props.minDate}
                          maxDate={this.props.maxDate}
                          isDateDisabled={this.props.isDateDisabled}
                          embedded={this.props.embedded}
                          showSpecialValue={this.props.showSpecialValue}
                          disableAutoFocus={this.props.disableAutoFocus}
                          onPreviewChange={this.handlePreviewChange}
                />
        );
    };
}